import extractDataFromColDefs from 'lib/helpers/exportPdf/lib/extractDataFromColDefs';

import { generateColumnDefs } from 'components/practice/BeyondBilling/Reports/components/ReportView/lib/generateColumnDefs';

// Function to flatten nested children data for CSV/Excel export
export const flattenNestedData = (rows, columns, parent) => {
  let result = [];

  // if no parent it means is the first iteration with selected columns
  const finalColumns = !parent ? columns : generateColumnDefs(rows);
  const formattedData = extractDataFromColDefs(rows, finalColumns);

  formattedData.forEach((row, index) => {
    const children = rows[index].children;
    const merged = { ...(parent || {}), ...row }; // merge parent fields with current row

    if (children && children.length > 0) {
      result = result.concat(flattenNestedData(children, finalColumns, merged));
    } else {
      result.push(merged);
    }
  });

  return result;
};
